import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { styled } from "@mui/material/styles";

const StyledToastContainer = styled(ToastContainer)`
  &.Toastify__toast-container--bottom-right {
    position: fixed !important;
    bottom: 16px !important;
    right: 16px !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
    width: auto !important;
    padding: 0 !important;
    z-index: 9999;
  }

  &.Toastify__toast-container {
    padding: 0 !important;
    width: auto !important;
  }

  .Toastify__toast {
    pointer-events: all;
    border-radius: 8px;
    padding: 0 !important;
    width: 320px !important;
    margin-bottom: 8px !important;
    min-height: unset !important;
    background: #1565c0;
    color: #fff;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-family: "Inter", sans-serif;
  }

  .Toastify__toast-body {
    padding: 0;
    margin: 0;
  }

  .Toastify__close-button {
    color: #fff;
    opacity: 1;
  }

  .Toastify__close-button:hover {
    color: #fff;
    opacity: 0.8;
  }


  .Toastify__progress-bar {
      background: rgba(255, 255, 255, 0.3) !important;
  height: 3px !important;
  }

  @media (max-width: 480px) {
    &.Toastify__toast-container--bottom-right {
      right: 8px;
      bottom: 8px;
      left: 8px;
    }

    .Toastify__toast {
      width: 100% !important;
    }
  }
`;

export default StyledToastContainer;
